import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eCauHinhLoaiDichVuActionTypeIds, ICauHinhLoaiDichVuActionTypes } from "../../action-types/dich-vu/ICauHinhLoaiDichVuActionTypes";
import { ICauHinhLoaiDichVuPageStateModel } from "../../page-state-model/dich-vu/ICauHinhLoaiDichVuPageState";

const initialState: ICauHinhLoaiDichVuPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	cauhinh_loaidichvus: [],
	cauhinh_loaidichvu_editing: undefined,
	cauhinh_loaidichvu_selected_ids: [],
	sf_loaidichvus: [],
	is_show_detail_modal: false,
	is_show_delete_confirm: false
}

export const cauHinhLoaiDichVuReducer = (state: ICauHinhLoaiDichVuPageStateModel = initialState, action: ICauHinhLoaiDichVuActionTypes): ICauHinhLoaiDichVuPageStateModel => {
	switch (action.type) {
		case eCauHinhLoaiDichVuActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eCauHinhLoaiDichVuActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				cauhinh_loaidichvus: action.payload
			}
		case eCauHinhLoaiDichVuActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				cauhinh_loaidichvus: []
			}
		case eCauHinhLoaiDichVuActionTypeIds.LOAD_LOAIDICHVU_START:
			return {
				...state
			}
		case eCauHinhLoaiDichVuActionTypeIds.LOAD_LOAIDICHVU_SUCCESS:
			return {
				...state,
				sf_loaidichvus: action.payload
			}
		case eCauHinhLoaiDichVuActionTypeIds.LOAD_LOAIDICHVU_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				sf_loaidichvus: []
			}
		case eCauHinhLoaiDichVuActionTypeIds.LOAD_DETAIL_START:
			return {
				...state
			}
		case eCauHinhLoaiDichVuActionTypeIds.LOAD_DETAIL_SUCCESS:
			return {
				...state,
				cauhinh_loaidichvu_editing: action.payload
			}
		case eCauHinhLoaiDichVuActionTypeIds.LOAD_DETAIL_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state
			}
		case eCauHinhLoaiDichVuActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				cauhinh_loaidichvu_editing: action.payload
			}
		case eCauHinhLoaiDichVuActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				cauhinh_loaidichvu_editing: undefined
			}
		case eCauHinhLoaiDichVuActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				cauhinh_loaidichvu_selected_ids: action.payload
			}
		case eCauHinhLoaiDichVuActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eCauHinhLoaiDichVuActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eCauHinhLoaiDichVuActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eCauHinhLoaiDichVuActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success(action.payload ? "Cập nhật thành công" : "Thêm mới thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				cauhinh_loaidichvu_editing: undefined
			}
		case eCauHinhLoaiDichVuActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eCauHinhLoaiDichVuActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eCauHinhLoaiDichVuActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false,
				cauhinh_loaidichvu_editing: undefined,
				cauhinh_loaidichvu_selected_ids: []
			}
		case eCauHinhLoaiDichVuActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		default:
			return state;
	}
}
